import { JsonEditor } from "json-edit-react"
import React from "react"
import { connect } from "react-redux"
import { WP_ACTIONS } from "./store"

function DetailsPage({ isReadOnly, details, onSaveDetails }) {
	// For now edit WP details as raw json
	return <JsonEditor data={details} setData={onSaveDetails} />
}

const mapStateToProps = state => {
	return {
		details: state.workingPapersReducer.workingPapers.details,
	}
}

const mapDispatchToProps = dispatch => ({
	onSaveDetails: (
		details // alert("ToDo"),
	) =>
		dispatch({
			type: WP_ACTIONS.SAVE_DETAILS,
			details,
		}),
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailsPage)
